<div class="sas-nav-item"
     [class.sas-nav-item--active]="active()"
     [class.sas-nav-item--collapsed]="collapsed()"
     [attr.data-label]="label() || null">
  <a class="nav-link"
     [attr.href]="resolvedHref()"
     [attr.target]="href() ? '_blank' : null"
     [attr.rel]="href() ? 'noopener noreferrer' : null"
     [attr.aria-label]="label() | translate"
     [class]="itemClass()"
     [tabindex]="tabIndex()"
     [attr.aria-current]="active() ? 'page' : null"
     [ngbTooltip]="isTooltipVisible() ? resolvedTooltipText() : ''"
     [disableTooltip]="!isTooltipVisible()"
     triggers="hover"
     [placement]="tooltipPlacement()"
     container="body"
     tooltipClass="sas-menu-tooltip"
     [openDelay]="150"
     (mouseenter)="onMouseEnter()"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut()"
     (click)="onLinkClick($event)">
    <ng-content></ng-content>
  </a>
</div>
